import request from "./request.js"

export function signIn(data) {
  return request({
    url: '/v1/auth/getAccessToken',
    method: 'post',
    params: data
  })
}
